import React, { useEffect, useState } from 'react';

const TermsAndConditionsPage = () => {
  const [termsData, setTermsData] = useState(null);

  useEffect(() => {
    // Mock fetch
    const fetchTermsAndConditions = async () => {
      const mockData = await Promise.resolve({
        "title": "Terms & Conditions",
        "lastUpdated": "October 2025",
        "content": `
          <p class="lead">Welcome to Tixbook.com ("Tixbook", "we", "our", or "us"). By accessing or using our website and services, you ("you", "user", "organizer", or "customer") agree to comply with and be bound by the following Terms and Conditions. If you do not agree, please do not use the Tixbook platform.</p>
          
          <h2>1. About Tixbook</h2>
          <p>Tixbook.com is an online platform based in London, United Kingdom, that enables users to browse, book, and purchase tickets for events organised by third-party event organisers. Tixbook acts as a facilitator and ticketing agent only. We do not host or manage events unless otherwise stated.</p>
          
          <h2>2. Definitions</h2>
          <ul>
            <li><strong>"Event Organiser"</strong> – a person or entity that creates, manages, and lists events on Tixbook.</li>
            <li><strong>"Attendee"</strong> – a person who purchases or holds a valid ticket for an event through Tixbook.</li>
            <li><strong>"Ticket"</strong> – an electronic or physical proof of entry to an event.</li>
            <li><strong>"Service"</strong> – any functionality provided by Tixbook, including ticket sales, booking management, and payment processing.</li>
          </ul>
          
          <h2>3. Acceptance of Terms</h2>
          <p>By using Tixbook's website or purchasing a ticket, you acknowledge that you have read, understood, and agree to these Terms and Conditions and any policies referenced within (including our Privacy Policy and Cookie Policy).</p>
          
          <h2>4. Use of the Platform</h2>
          <ul>
            <li>You agree to use Tixbook only for lawful purposes.</li>
            <li>You must not misuse the site, attempt to hack it, or engage in fraudulent activity.</li>
            <li>Tixbook may suspend or terminate your access without prior notice if we suspect misuse or breach of these Terms.</li>
          </ul>
          
          <h2>5. Account Registration</h2>
          <ul>
            <li>Some features of the platform may require you to create a user account.</li>
            <li>You agree to provide accurate, current, and complete information.</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You must notify Tixbook immediately of any unauthorised use of your account.</li>
          </ul>
          
          <h2>6. Ticket Sales and Event Listings</h2>
          <ul>
            <li>Tickets listed on Tixbook are sold by independent organisers, unless otherwise specified.</li>
            <li>Tixbook acts as a ticketing intermediary between organisers and attendees.</li>
            <li>Each event's details, pricing, and terms (including age restrictions and entry policies) are determined by the organiser.</li>
            <li>Tickets are valid only for the specific event, date, and time stated on them.</li>
          </ul>
          
          <h2>7. Pricing and Payments</h2>
          <ul>
            <li>All prices are shown in GBP (£) and include applicable taxes unless otherwise stated.</li>
            <li>Payment is processed securely through approved third-party payment gateways.</li>
            <li>By purchasing a ticket, you authorise Tixbook (or its payment partners) to charge your payment method for the total transaction amount, including service fees where applicable.</li>
          </ul>
          
          <h2>8. Refunds, Cancellations, and Exchanges</h2>
          <ul>
            <li>Refunds are generally subject to the event organiser's policy.</li>
            <li>If an event is cancelled, postponed, or materially changed, Tixbook will coordinate refunds as instructed by the organiser.</li>
            <li>Tixbook service fees are non-refundable, except where required by law.</li>
            <li>To request a refund, users must contact Tixbook or the organiser through the official channels listed on the website.</li>
          </ul>
          
          <h2>9. Event Changes and Cancellations</h2>
          <ul>
            <li>Organisers may change or cancel events at their discretion.</li>
            <li>Tixbook is not liable for costs incurred due to event alterations, including travel or accommodation.</li>
            <li>We will make reasonable efforts to notify affected ticket holders of any changes.</li>
          </ul>
          
          <h2>10. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Violate any applicable UK laws or regulations.</li>
            <li>Use automated means (bots, scrapers) to access the site.</li>
            <li>Resell or duplicate tickets without authorisation.</li>
            <li>Post false, misleading, or defamatory content.</li>
          </ul>
          
          <h2>11. Intellectual Property</h2>
          <p>All content on Tixbook.com, including text, graphics, logos, icons, software, and trademarks, is the property of Tixbook or its licensors and is protected under UK copyright and intellectual property laws. You may not reproduce, modify, distribute, or exploit any material from the site without written consent.</p>
          
          <h2>12. Limitation of Liability</h2>
          <ul>
            <li>Tixbook provides the platform "as is" and makes no warranties about availability, accuracy, or fitness for purpose.</li>
            <li>Tixbook shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of our services or attendance at events listed on our platform.</li>
            <li>Our total liability to you shall not exceed the total amount paid for the ticket in question.</li>
          </ul>
          
          <h2>13. Indemnity</h2>
          <p>You agree to indemnify and hold harmless Tixbook, its directors, employees, and partners from any claims, damages, or losses arising from your use of the platform or breach of these Terms.</p>
          
          <h2>14. Third-Party Links</h2>
          <p>The website may contain links to third-party websites. Tixbook is not responsible for the content, security, or privacy practices of those websites.</p>
          
          <h2>15. Data Protection and Privacy</h2>
          <p>Your personal data is collected and processed in accordance with UK GDPR and our Privacy Policy. By using Tixbook, you consent to the use of cookies and data processing as described in those policies.</p>
          
          <h2>16. Age Restrictions</h2>
          <p>Certain events may have age restrictions as determined by organisers. You must comply with those restrictions and provide valid ID if required.</p>
          
          <h2>17. Force Majeure</h2>
          <p>Tixbook shall not be liable for failure to perform any obligation due to causes beyond our reasonable control, including natural disasters, strikes, war, or technical failures.</p>
          
          <h2>18. Modifications to Terms</h2>
          <p>Tixbook may update these Terms & Conditions from time to time. Any changes will be posted on this page with a revised "Last Updated" date. Continued use of the website after changes constitutes acceptance of the updated Terms.</p>
          
          <h2>19. Governing Law and Jurisdiction</h2>
          <p>These Terms are governed by and construed in accordance with the laws of England and Wales. You agree to submit to the exclusive jurisdiction of the English courts in relation to any dispute.</p>
          
          <h2>20. Contact Information</h2>
          <p>For questions, concerns, or legal inquiries, please contact:</p>
          <p><strong>Tixbook Ltd.</strong><br/>
          Email: <a href="mailto:hello@tixbook.com">hello@tixbook.com</a><br/>
          London, United Kingdom</p>
        `
      });
      setTermsData(mockData);
    };

    fetchTermsAndConditions();
  }, []);

  return (
    <div className="container py-5 terms-conditions-page">
      {termsData ? (
        <>
          <h1 className="mb-2">{termsData.title}</h1>
          <p className="text-muted mb-4">Last Updated: {termsData.lastUpdated}</p>
          <div dangerouslySetInnerHTML={{ __html: termsData.content }} />
        </>
      ) : (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading terms and conditions...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TermsAndConditionsPage;

